import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_OPTIONS, URL_SERVICIOS } from '../shared/config/config';
import { AditionalInfo } from '../interfaces/aditional-info.interface';
const endpoint = `${URL_SERVICIOS}AditionInfo`;

@Injectable({
  providedIn: 'root'
})
export class AditionalInfoService {

  constructor(private http: HttpClient) { }

  getAditionalByPetition = (petId: number) => this.http.get<AditionalInfo[]>(`${endpoint}/petition/${petId}`, HTTP_OPTIONS).toPromise();

  createMultAditionalQuestion = (questions: AditionalInfo[]) =>
    this.http.post<AditionalInfo[]>(`${endpoint}/multi`, questions, HTTP_OPTIONS).toPromise()

  answerAditionalQuestion = (questions: AditionalInfo[]) =>
    this.http.put(`${endpoint}/answer`, questions, HTTP_OPTIONS).toPromise()
}